import styled from "@emotion/styled";
import { IonPage } from "@ionic/react";
import "./style.scss";

const StyledIonPage = styled(IonPage)`
  padding-top: env(safe-area-inset-top);
`;

export { StyledIonPage };
